import { getSelectedSiteIds } from '../../selectors/sites/get-selected-site-ids';
/**
 * Returns a ShowtimeQuery object that contains the filmId and siteId filters for the Showtime Picker component,
 * based on the current config and browsing store selections.
 */
export const getShowtimesQuery = (filmIds, siteIds) => {
    return {
        filmIds,
        siteIds: siteIds !== null && siteIds !== void 0 ? siteIds : getSelectedSiteIds()
    };
};
